import { Editor } from '@tiptap/core';
import { defaultConfig } from './config';
import { EditorEvents } from './events';
import { createTextFeatures } from '../features/text';
import { createHistoryFeatures } from '../features/history';
import { createFormattingFeatures } from '../features/formatting';
import { createLinkFeatures } from '../features/links';
import { createBubbleMenuFeatures } from '../features/bubble-menu';
import Placeholder from '@tiptap/extension-placeholder';

// Глобальный экземпляр редактора
let globalEditor = null;

// Функция для получения экземпляра редактора
export const getEditor = () => globalEditor;

export default (content, actions = true) => {
  let editor;
  let events;

  const instance = {
    content,
    actions,
    updatedAt: Date.now(),
    isLoading: false,
    headingsList: [],

    async init() {
      // Формируем расширения в зависимости от actions
      const extensions = [
        ...defaultConfig.extensions,
        {
          name: 'editorInstance',
          addStorage() {
            return {
              instance: instance
            };
          }
        }
      ];
      
      // Добавляем плейсхолдер только если actions=true
      if (this.actions) {
        extensions.push(
          Placeholder.configure({
            placeholder: 'Нажмите пробел, что бы открыть ИИ ассистента...',
            emptyEditorClass: 'is-editor-empty',
            emptyNodeClass: 'is-node-empty',
          })
        );
      }

      editor = new Editor({
        element: this.$refs.element,
        content: this.content,
        ...defaultConfig,
        extensions: extensions,
        onCreate: ({ editor }) => {
          this.updateHistoryButtons?.();
          this.updatedAt = Date.now();
          // Сохраняем глобальный экземпляр
          globalEditor = editor;
        },
        onUpdate: ({ editor }) => {
          this.updatedAt = Date.now();
          this.content = editor.getHTML();
          this.updateHistoryButtons?.();
        },
        onSelectionUpdate: () => {
          this.updatedAt = Date.now();
        }
      });

      Object.assign(this,
        createFormattingFeatures(editor),
      );

      if (this.actions) {
        // Добавляем функциональность из модулей
        Object.assign(this,
          createTextFeatures(editor),
          createHistoryFeatures(editor),
          createLinkFeatures(editor),
          createBubbleMenuFeatures(editor)
        );

        // Создаем bubble menu и ждем его инициализации
        this.bubbleMenu = await this.createBubbleMenu();

        events = new EditorEvents(this);
        this.updatedAt = Date.now();
      }

    },

    // Базовые методы
    isLoaded() {
      return !!editor;
    },

    getEditor() {
      return editor;
    },

    isActive(type, opts = {}) {
      if (!editor) return false;
      return editor.isActive(type, opts);
    },

    destroy() {
      if (editor) {
        editor.destroy();
        globalEditor = null;
      }
    }
  };

  return instance;
};